import { useState } from "react"
import Modal from "../../components/Modal"
import { formatCurrency } from "../../Helpers"

const SHOWN_STATEMENTS = 4

interface PendingFiling {
    title: string
    preview: FilingPreview
    apply: () => Promise<unknown>
}

// Changer le rangement d'un compte re-range tout son historique : la fenêtre montre les relevés
// obtenus avant d'appliquer. Sans opération à déplacer, le changement s'applique directement.
export const useFilingConfirmation = () => {
    const [pending, setPending] = useState(null as PendingFiling | null)
    const [saving, setSaving] = useState(false)

    const confirm = (title: string, preview: FilingPreview | null, apply: () => Promise<unknown>) => {
        if(preview && preview.moved_count > 0) {
            setPending({ title, preview, apply })
            return Promise.resolve()
        }
        return apply()
    }

    const run = () => {
        if(!pending) {
            return
        }
        setSaving(true)
        pending.apply().finally(() => {
            setSaving(false)
            setPending(null)
        })
    }

    const modal = pending && <Modal onCancel={() => !saving && setPending(null)}>
        <FilingSummary pending={pending} saving={saving} onConfirm={run} onCancel={() => setPending(null)}/>
    </Modal>

    return { confirm, modal }
}

const plural = (count: number, word: string) => `${count} ${word}${count > 1 ? 's' : ''}`

const FilingSummary = ({ pending, saving, onConfirm, onCancel }: { pending: PendingFiling, saving: boolean, onConfirm: () => void, onCancel: () => void }) => {
    const { preview } = pending
    const statements = preview.statements
    const hidden = statements.slice(SHOWN_STATEMENTS)

    return <div className="filing-modal">
        <h3>{ pending.title }</h3>
        <p className="muted">
            { plural(preview.count, 'opération') }, dont { plural(preview.moved_count, 'déplacée') }. Les budgets, libellés et parts ne changent pas.
        </p>
        <div className="filing-preview">
            { statements.slice(0, SHOWN_STATEMENTS).map((statement) => <div key={statement.filename} className="filing-statement">
                <span>{ statement.filename }</span>
                <span>{ plural(statement.count, 'opération') } · { formatCurrency(statement.total_cents) }</span>
            </div>) }
            { hidden.length > 0 && <div className="filing-statement">
                <span>… { plural(hidden.length, 'autre relevé') }</span>
                <span>{ plural(hidden.reduce((sum, statement) => sum + statement.count, 0), 'opération') }</span>
            </div> }
        </div>
        <div className="buttons">
            <button type="button" className="tl-btn tl-btn-ghost" disabled={saving} onClick={onCancel}>Annuler</button>
            <button type="button" className="tl-btn tl-btn-primary" disabled={saving} onClick={onConfirm} autoFocus>
                { saving
                    ? 'Rangement…'
                    : statements.length === 1 ? `Tout ranger dans « ${statements[0].filename} »` : `Ranger en ${statements.length} relevés` }
            </button>
        </div>
    </div>
}
